export default __webpack_public_path__ + "static/TOUCH ME - ANTIFINGER PRINT LAMINATE-602fd24447a9bb75fbaa462bb1485114.webp";